module.exports = __webpack_public_path__ + "static/04-cb24c1bdbbc0bbe47b3bfe4600a5eae1.jpg";